<yo-generic-datagrid-pn [pathFileHelp]="pathFile" [service]="motifNonConformiteSvc"></yo-generic-datagrid-pn>
